import { render, staticRenderFns } from "./OrderTotalSummary.vue?vue&type=template&id=81270818&scoped=true"
import script from "./OrderTotalSummary.vue?vue&type=script&lang=js"
export * from "./OrderTotalSummary.vue?vue&type=script&lang=js"
import style0 from "./OrderTotalSummary.vue?vue&type=style&index=0&id=81270818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81270818",
  null
  
)

export default component.exports